module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }